export default "__VITE_PUBLIC_ASSET__e9619593__"